var is = require('@souche-f2e/chunyan-util/sc-is/is-c');

var select_city = require('../select_city/select_city');
var cityService = require('../../services/cityService');
var userApi = require('../../../../api-computed/from-traffic/userApi');

var tpl = require('./sellcar_main_tpl.html');

let $ = window.$;

var _store = {
    $dom: $('<div>'),
    $html: {},
    activeCode: $.cookie('ipCity'),
    _more: ''
};

var _services = {
    saveSellCar: function (data) {
        return userApi.getUserTag().then(getUserTagData => $.ajax({
            url: '/jsonp/api/sellCar.json',
            type: 'get',
            dataType: 'jsonp',
            data: {
                ...data,
                usertag: getUserTagData.data.usertag
            }
        }));
    },
    login: function (phone) {
        return $.ajax({
            url: '/json/login.json',
            type: 'post',
            dataType: 'json',
            data: {
                phone: phone
            }
        });
    }
};

var _control = {
    init: function () {
        this.bind(tpl);
    },
    bind: function (html) {
        _store.$html = $(html)
            .on('click', '.J_select_city', function(event) {
                event.preventDefault();
                select_city.do(function (code) {
                    $.when(cityService.getCityByCode_async(code)).then(function (data) {
                        _store.$html
                        .find('.J_select_city').attr('data-value', code)
                        .find('.section_select')
                        .removeClass('select_default')
                        .find('.select_value')
                        .text(data);
                    });
                });
            }).on('click', '.J_submit_sale', function(event) {
                event.preventDefault();
                var $this = $(this);

                // 校验手机号，并提交信息
                var ex_data = {
                    phone: $('.J_input_phone').val()
                };
                // 校验手机号
                if (!is.phone(ex_data.phone)) {
                    alert('请输入正确的手机号');
                    return false;
                }
                // 获取城市
                var cityCode = _store.$html.find('.J_select_city').attr('data-value');
                if (!cityCode) {
                    alert('请选择一个城市');
                    return false;
                }

                $this.removeClass('J_submit_sale').addClass('disabled').text('正在提交...');
                $.when(_services.login(ex_data.phone), cityService.getByCode_async(cityCode))
                .then(function (login_data, city_data) {
                    var data;
                    if (login_data[1] === 'success') {
                        data = login_data[0];
                    } else {
                        return false;
                    }
                    if (!data) {
                        console.error('未知错误！');
                    } else if (data.code === 0 && data.item && data.item.crmUserId) {
                        ex_data.crmUserId = data.item.crmUserId;
                        ex_data.shopId = city_data[0].code;
                        ex_data.seller = _store.$html.find('.J_input_name').val();
                        ex_data.desc = _store.$html.find('.J_input_desc').val();
                        return _services.saveSellCar(ex_data);
                    } else if (data.msg) {
                        alert(`${data.code}:${data.msg}`);
                    } else {
                        alert('未知错误！');
                    }
                    return false;
                }).then(function (data) {
                    if (!data) {
                        console.error('未知错误！');
                    } else {
                        alert('提交成功，稍后客服会主动联系您，请确保您的手机号可以联系到您.');
                        $this.text('已成功预约卖车');
                    }
                });
            })
            .appendTo(_store.$dom);

        _store.$html.find('.select_city').append(select_city.$dom);

        $('body').on('click', function(event) {
            // event.preventDefault();
            if (!$(event.target).closest(_store.$html.find('.select_city')).length) {
                select_city.$dom.find('.slide-select-wrapper').addClass('hidden');
            }
        });

        if (!_store.activeCode) {
            // 如果没有默认城市，取城市列表，选中第一位
            $.when(cityService.getCity_async()).then(function (data) {
                _store.$html
                .find('.J_select_city').attr('data-value', data[0].code)
                .find('.select_value')
                .text(data[0].name);
            });
        } else {
            $.when(cityService.getCityByCode_async(_store.activeCode)).then(function (data) {
                if (!data) {
                    return $.when(cityService.getCity_async());
                } else {
                    _store.$html
                    .find('.J_select_city').attr('data-value', _store.activeCode)
                    .find('.select_value')
                    .text(data);
                    return false;
                }
            }).then(function (data) {
                if (!data) {
                    return false;
                } else {
                    _store.$html
                    .find('.J_select_city').attr('data-value', data[0].code)
                    .find('.select_value')
                    .text(data[0].name);
                    return false;
                }
            });
        }
    },
    _more: ''
};

_control.init();

module.exports = {
    $dom: _store.$dom,
    _more: ''
};



// WEBPACK FOOTER //
// ./src/modules/sellcar/modules/sellcar_main/sellcar_main.js